<template>
    <ul class="nav justify-content-center pt-4 pb-5 portfolio-nav">
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'portfolio.details', params: { id: $route.params.portfolio } }" :class="[$route.name === 'portfolio.approvals' ? 'active' : '']" exact>
                <div class="nav-img">
                    <img :src="group" class="img-fluid" alt="">
                </div>
                Portfolio
            </router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'dashboard' }">
                <div class="nav-img">
                    <img :src="back" class="img-fluid" alt="">
                </div>
                Back<span class="hide"> to Dashboard</span>
            </router-link>
        </li>
    </ul>
</template>

<style scoped>
	.portfolio-nav .nav-item {
		margin: 0px 20px;
	}

	.portfolio-nav .nav-item .nav-link {
		text-align: center;
	}

	.portfolio-nav .nav-img {
		width: 40px;
		margin: auto;
		margin-bottom: 10px;
	}

	.portfolio-nav .nav-item {
		margin: 0px 10px;
	}

	@media (max-width: 425px) {
		.portfolio-nav .nav-item {
			margin: 0px 0px;
		}

		.portfolio-nav .nav-img {
			width: 20px;
			margin-bottom: 0px;
		}

		.hide {
			display: none;
		}
	}
</style>

<script>
import group from '../../../../../../img/growth.svg'
import back from '../../../../../../img/return.svg'

export default {
    data() {
        return {
            group,
            back
        }
    },
}
</script>
